import {
  addEventProcessor,
  browserTracingIntegration,
  captureConsoleIntegration,
  extraErrorDataIntegration,
  init as sentryInit,
} from '@sentry/react';

let init = false;

export function initSentry() {
  initSentryWithAppInfo();
}

function normalizeUrl(url: string, pathStripeRe: RegExp): string {
  return url.replace(pathStripeRe, '');
}

function initSentryWithAppInfo() {
  if (init) {
    console.error('Attempted to double-initialize Sentry');
    return;
  }
  init = true;

  const PATH_STRIP_RE = /(http|capacitor):\/\/localhost/;

  sentryInit({
    dsn: '',
    release: process.env.REACT_APP_VERSION,
    integrations: [
      extraErrorDataIntegration({ depth: 1 }),
      captureConsoleIntegration({ levels: ['error'] }),
      browserTracingIntegration(),
    ],
  });

  //https://www.youtube.com/watch?v=iGuqUtHGTj8
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  addEventProcessor((data: any) => {
    if (data.culprit) {
      data.culprit = normalizeUrl(data.culprit, PATH_STRIP_RE);
    }
    const stacktrace =
      data.stacktrace || (data.exception && data.exception.values && data.exception.values[0].stacktrace);
    if (stacktrace) {
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      stacktrace.frames.forEach((frame: any) => {
        if (frame.filename !== '[native code]' && frame.filename !== '<anonymous>') {
          frame.filename = normalizeUrl(frame.filename, PATH_STRIP_RE);
        }
      });
    }
    return data;
  });

  console.log('Initialized Sentry');
}
